<!-- Modal (Communicator (Solução de Problemas)) -->

<ng-template #communicatorSolucaoDeProblemas let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-communicator-solucao-de-problemas"><b>Communicator (Solução de Problemas)</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="d-flex flex-column">
      <div class="subtitulo mt-2 mb-2">Solução 1 - Validação de certificado pelo Google Chrome.</div>

      <div class="pt-2">
        1. Acesse o link: <a href="https://localhost.ucclient.net:5506" target="_blank">https://localhost.ucclient.net:5506</a>;
      </div>

      <div>
        2. Na página que se abre clique no botão <b>Avançado</b>;
      </div>

      <div>
        3. Logo abaixo clique em <b>Ir para localhost.ucclient.net</b>.
      </div>

      <div>
        <hr class="mt-2 mb-2" />
      </div>

      <div class="subtitulo mt-2 mb-2">Solução 2 - Verifique a data/hora do computador.</div>

      <div class="pt-2">
        Caso a data/hora do seu computador esteja incorreta siga os passos abaixo:
      </div>

      <div class="pt-2">
        1. Acesse <b>Painel de Controle</b> pelo menu iniciar;
      </div>

      <div>
        2. Escolha a opção <b>Relógio, Idioma e Região</b>;
      </div>

      <div>
        3. Selecione a opção <b>Data e Hora</b>;
      </div>

      <div>
        4. Nas abas superiores selecione <b>Horário na Internet</b>;
      </div>

      <div>
        5. Clique no botão <b>Alterar configurações</b>;
      </div>

      <div>
        6. Marque a opção <b>Sincronizar com um servidor de horário na Internet</b>;
      </div>

      <div>
        7. Selecione o servidor <b>time.windows.com</b>;
      </div>

      <div>
        8. Salve as alterações.
      </div>

      <div>
        <hr class="mt-2 mb-2" />
      </div>

      <div class="subtitulo mt-2 mb-2">Solução 3 - Liberação de URL no servidor proxy.</div>

      <div class="pt-2">
        1. Entre em contato com seu departamento de TI e solicite a inclusão da URL contida no <b>item 2</b>;
      </div>

      <div>
        2. <b>https://localhost.ucclient.net:5506</b>.
      </div>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

<!-- Modal (WhatsApp (Imagens)) -->

<ng-template #whatsAppImagens let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-whatsapp-imagens"><b>WhatsApp (Imagens)</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="d-flex flex-wrap justify-content-center">
      <img class="imagem" [src]="canaisComunicacaoWhatsAppChatImagemSelecionada.imageUrl" alt="Imagem" />
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

<!-- Modal (WhatsApp (Transferir)) -->

<ng-template #whatsAppTransferir let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-whatsapp-transferir"><b>WhatsApp (Transferir)</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <!-- Vendedor(a) -->

    <div class="form-row">
      <div class="form-group col-sm-12">
        <label><b>Vendedor(a):</b></label>

        <select class="form-control form-control-sm" name="vendedor" #vendedor (change)="selecionarVendedor(vendedor.value)" [ngClass]="{ 'is-invalid': vendedorInvalido }">
          <option value="0" [selected]="vendedorSelecionado == null"></option>

          @for (opcao of vendedores; track opcao) {
            <option [value]="opcao.id" [selected]="vendedorSelecionado != null ? opcao.id == vendedorSelecionado.id : null">{{ opcao.fullname }}</option>
          }
        </select>

        @if (vendedorInvalido) {
          <div class="erro pt-1">Vendedor(a) em branco!</div>
        }
      </div>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Cancelar')">Cancelar</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Transferir')">Transferir</button>
  </div>
</ng-template>

<!-- Lateral -->

@if (central_atendimento_estilo == 'lateral') {
  <div class="central_atendimento_lateral" [@centralAtendimentoLateral]="maximizar ? 'aumentar' : 'diminuir'" #centralAtendimento>
    <div class="d-flex flex-column">
      <!-- Título -->
      <div class="central_atendimento_titulo_lateral pt-4 pr-2 pb-4 pl-2" #centralAtendimentoTitulo>
        <!-- Maximizada -->
        @if (maximizar) {
          <div class="d-flex flex-wrap justify-content-between">
            <!-- Texto -->
            <div class="d-flex flex-wrap">
              <div class="pr-2">
                <b>Central de Atendimento</b>
              </div>
              @if (qtdeEventosNaoVisualizados > 0) {
                <div>
                  <span class="badge badge-danger">
                    {{ qtdeEventosNaoVisualizados }}
                  </span>
                </div>
              }
            </div>
            <!-- Ações (Central/Evento) -->
            <div class="d-flex justify-content-center">
              @if (maximizar) {
                <div class="pr-2" (click)="limparEventos()">
                  <i class="fa fa-eraser central_atendimento_titulo_acoes" placement="left" ngbTooltip="Limpar Eventos"></i>
                </div>
              }
              <div (click)="alterarMinimizarMaximizar()">
                <i class="fa  central_atendimento_titulo_acoes" [ngClass]="maximizar ? 'fa-chevron-left' : 'fa-chevron-right'" placement="left" [ngbTooltip]="maximizar ? 'Minimizar' : 'Maximizar'"></i>
              </div>
            </div>
          </div>
        }
        <!-- Minimizada -->
        @if (!maximizar) {
          <div class="d-flex flex-wrap justify-content-center">
            <!-- Texto -->
            <div class="d-flex flex-wrap justify-content-center">
              <div>
                <b>C. A.</b>
              </div>
              @if (qtdeEventosNaoVisualizados > 0) {
                <div class="pt-2">
                  <span class="badge badge-danger">
                    {{ qtdeEventosNaoVisualizados }}
                  </span>
                </div>
              }
            </div>
            <!-- Ações (Central/Evento) -->
            <div class="d-flex justify-content-center">
              <div class="pt-2">
                <div (click)="alterarMinimizarMaximizar()">
                  <i class="fa  central_atendimento_titulo_acoes" [ngClass]="maximizar ? 'fa-chevron-left' : 'fa-chevron-right'" placement="right" [ngbTooltip]="maximizar ? 'Minimizar' : 'Maximizar'"></i>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
      <!-- Título (Abas) -->
      @if (maximizar) {
        <div class="central_atendimento_titulo_abas p-2" #centralAtendimentoTituloAbas>
          <div class="d-flex justify-content-center">
            <!-- E-mail -->
            @if (usa_email) {
              <div class="pr-2">
                <div class="d-flex align-items-end">
                  <img class="central_atendimento_titulo_abas_imagem" src="../../../assets/icones/icone_email.png" alt="E-mail" placement="right" ngbTooltip="E-mail" (click)="alterarTabSelecionada('email')" />
                  @if (qtdeEventosNaoVisualizadosEmail > 0) {
                    <div class="pl-1">
                      <span class="badge badge-danger">
                        {{ qtdeEventosNaoVisualizadosEmail }}
                      </span>
                    </div>
                  }
                </div>
              </div>
            }
            <!-- Facebook -->
            @if (usa_facebook) {
              <div class="pr-2">
                <div class="d-flex align-items-end">
                  <img class="central_atendimento_titulo_abas_imagem" src="../../../assets/icones/icone_facebook.png" alt="Facebook" placement="right" ngbTooltip="Facebook" (click)="alterarTabSelecionada('facebook')" />
                  @if (qtdeEventosNaoVisualizadosFacebook > 0) {
                    <div class="pl-1">
                      <span class="badge badge-danger">
                        {{ qtdeEventosNaoVisualizadosFacebook }}
                      </span>
                    </div>
                  }
                </div>
              </div>
            }
            <!-- Telefonia -->
            @if (usa_pabx) {
              <div class="pr-2">
                <div class="d-flex align-items-end">
                  <img class="central_atendimento_titulo_abas_imagem" src="../../../assets/icones/icone_telefonia.png" alt="Telefonia" placement="right" ngbTooltip="Telefonia" (click)="alterarTabSelecionada('telefonia')" />
                  @if (qtdeEventosNaoVisualizadosTelefonia > 0) {
                    <div class="pl-1">
                      <span class="badge badge-danger">
                        {{ qtdeEventosNaoVisualizadosTelefonia }}
                      </span>
                    </div>
                  }
                </div>
              </div>
            }
            <!-- WhatsApp -->
            @if (usa_whatsapp) {
              <div class="pr-2">
                <div class="d-flex align-items-end">
                  <img class="central_atendimento_titulo_abas_imagem" src="../../../assets/icones/icone_whatsapp.png" alt="WhatsApp" placement="right" ngbTooltip="WhatsApp" (click)="alterarTabSelecionada('whatsapp')" />
                  @if (qtdeEventosNaoVisualizadosWhatsApp > 0) {
                    <div class="pl-1">
                      <span class="badge badge-danger">
                        {{ qtdeEventosNaoVisualizadosWhatsApp }}
                      </span>
                    </div>
                  }
                </div>
              </div>
            }
            <!-- Todos -->
            <div class="pr-2">
              <div class="d-flex align-items-end">
                <img class="central_atendimento_titulo_abas_imagem" src="../../../assets/icones/icone_todos.png" alt="Todos" placement="right" ngbTooltip="Todos" (click)="alterarTabSelecionada('todos')" />
                @if (qtdeEventosNaoVisualizados > 0) {
                  <div class="pl-1">
                    <span class="badge badge-danger">
                      {{ qtdeEventosNaoVisualizados }}
                    </span>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
      <!-- Eventos -->
      <div class="central_atendimento_evento" [@centralAtendimentoEvento]="maximizar ? 'aparecer' : 'esconder'" #centralAtendimentoEvento>
        @for (centralAtendimentoEventoVisivel of centralAtendimentoEventosVisiveis; track centralAtendimentoEventoVisivel; let i = $index) {
          @if (centralAtendimentoEventoVisivel.exibir) {
            <div class="central_atendimento_evento_item p-2" [ngClass]="centralAtendimentoEventoVisivel.tipo == 'whatsapp' ? 'central_atendimento_evento_item_acao' : ''" (mouseover)="visualizarEvento(centralAtendimentoEventoVisivel.visualizado, centralAtendimentoEventoVisivel.id)" (click)="abrirEvento(centralAtendimentoEventoVisivel.id)">
              <div class="d-flex">
                <!-- Título/Mensagem/Ações -->
                <div class="flex-grow-1">
                  <div class="d-flex flex-column">
                    <div class="flex-grow-1 central_atendimento_evento_item_titulo pr-2">
                      <div class="d-flex">
                        <div class="pr-2">
                          {{ centralAtendimentoEventoVisivel.titulo }}
                        </div>
                        @if (centralAtendimentoEventoVisivel.mensagem_contador > 0) {
                          <div>
                            <span class="badge badge-danger">
                              {{ centralAtendimentoEventoVisivel.mensagem_contador }}
                            </span>
                          </div>
                        }
                      </div>
                    </div>
                    <div class="flex-grow-1 central_atendimento_evento_item_mensagem pr-2">
                      <div class="d-flex">
                        <div class="flex-grow-1 d-flex flex-column">
                          <div [ngClass]="!centralAtendimentoEventoVisivel.visualizado ? 'font-weight-bold' : ''">
                            {{ centralAtendimentoEventoVisivel.mensagem }}
                          </div>
                          @if (centralAtendimentoEventoVisivel.identificacao != '') {
                            <div [ngClass]="!centralAtendimentoEventoVisivel.visualizado ? 'font-weight-bold' : ''">
                              {{ centralAtendimentoEventoVisivel.identificacao }}
                            </div>
                          }
                          <!-- Ações -->
                          <div>
                            <!-- Telefonia -->
                            @if (centralAtendimentoEventoVisivel.tipo == 'telefonia' && centralAtendimentoEventoVisivel.atender) {
                              <div class="pt-2">
                                <button class="btn btn-secondary btn_acao" type="button" (click)="telefoniaAtender(centralAtendimentoEventoVisivel.codigo_no_erp_do_cliente)">Atender</button>
                              </div>
                            }
                            @if (centralAtendimentoEventoVisivel.tipo == 'telefonia' && centralAtendimentoEventoVisivel.redirecionar) {
                              <div class="pt-2">
                                <button class="btn btn-secondary btn_acao" type="button" (click)="telefoniaRedirecionar(centralAtendimentoEventoVisivel.codigo_no_erp_do_cliente)">Redirecionar</button>
                              </div>
                            }
                            @if (centralAtendimentoEventoVisivel.tipo == 'telefonia' && centralAtendimentoEventoVisivel.tentar_novamente) {
                              <div class="pt-2">
                                <div class="d-flex flex-column">
                                  @if (tipo_softphone == 1) {
                                    <div class="pb-2">
                                      <button class="btn btn-secondary btn_acao" type="button" (click)="modalCommunicatorSolucaoDeProblemas(communicatorSolucaoDeProblemas)">Solução de Problemas</button>
                                    </div>
                                  }
                                  <div>
                                    <button class="btn btn-secondary btn_acao" type="button" (click)="telefoniaTentarNovamente()">Tentar Novamente</button>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center">
                  <div class="d-flex flex-column align-items-center">
                    <!-- Imagem -->
                    <div>
                      @if (centralAtendimentoEventoVisivel.tipo == 'email') {
                        <img class="central_atendimento_evento_item_imagem_lateral" src="../../../assets/icones/icone_email.png" alt="E-mail" />
                      }
                      @if (centralAtendimentoEventoVisivel.tipo == 'facebook') {
                        <img class="central_atendimento_evento_item_imagem_lateral" src="../../../assets/icones/icone_facebook.png" alt="Facebook" />
                      }
                      @if (centralAtendimentoEventoVisivel.tipo == 'telefonia') {
                        <img class="central_atendimento_evento_item_imagem_lateral" src="../../../assets/icones/icone_telefonia.png" alt="Telefonia" />
                      }
                      @if (centralAtendimentoEventoVisivel.tipo == 'whatsapp') {
                        <img class="central_atendimento_evento_item_imagem_lateral" src="../../../assets/icones/icone_whatsapp.png" alt="WhatsApp" />
                      }
                    </div>
                    <!-- Data/Hora -->
                    <div class="central_atendimento_evento_item_datahora text-secondary pt-2">
                      {{ centralAtendimentoEventoVisivel.data_hora | date: 'dd/MM/yyyy' }}
                    </div>
                    <div class="central_atendimento_evento_item_datahora text-secondary">
                      {{ centralAtendimentoEventoVisivel.data_hora | date: 'HH:mm:ss' }}
                    </div>
                  </div>
                  <!-- Ações (Evento) -->
                  <div class="pl-2">
                    <i class="fa fa-remove central_atendimento_evento_item_acao" placement="top" ngbTooltip="Excluir" (click)="excluirEvento(centralAtendimentoEventoVisivel.id)"></i>
                  </div>
                </div>
              </div>
            </div>
          }
        }
        <!-- Nenhum (Evento) -->
        @if (centralAtendimentoEventosVisiveis.length == 0) {
          <div class="d-flex justify-content-center align-items-center central_atendimento_evento_item_nenhum">
            <div>
              Nenhum evento localizado!
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}

<!-- Móvel -->

@if (central_atendimento_estilo == 'movel') {
  <div class="central_atendimento_movel ml-4 mr-4" #centralAtendimento>
    <div class="d-flex flex-column">
      <div class="central_atendimento_titulo_movel p-3"
        (mousedown)="onMouseDownCentralAtendimento($event)"
        (mouseleave)="onMouseLeaveCentralAtendimento()"
        (mousemove)="onMouseMoveCentralAtendimento($event)"
        (mouseup)="onMouseUpCentralAtendimento()"
        #centralAtendimentoTitulo>
        <!-- Título -->
        <div class="d-flex justify-content-between">
          <div class="d-flex flex-wrap">
            <div class="pr-2">
              <b>Central de Atendimento</b>
            </div>
            @if (qtdeEventosNaoVisualizados > 0) {
              <div>
                <span class="badge badge-danger">
                  {{ qtdeEventosNaoVisualizados }}
                </span>
              </div>
            }
          </div>
          <!-- Ações (Central/Evento) -->
          <div class="d-flex">
            <div class="pr-2" (click)="limparEventos()">
              <i class="fa fa-eraser central_atendimento_titulo_acoes" placement="top" ngbTooltip="Limpar Eventos"></i>
            </div>
            <div (click)="alterarMinimizarMaximizar()">
              <i class="fa  central_atendimento_titulo_acoes" [ngClass]="maximizar ? 'fa-chevron-down' : 'fa-chevron-up'" placement="top" [ngbTooltip]="maximizar ? 'Minimizar' : 'Maximizar'"></i>
            </div>
          </div>
        </div>
      </div>
      <!-- Eventos -->
      @if (maximizar) {
        <div class="central_atendimento_evento" #centralAtendimentoEvento>
          @for (centralAtendimentoEventoVisivel of centralAtendimentoEventosVisiveis; track centralAtendimentoEventoVisivel; let i = $index) {
            @if (centralAtendimentoEventoVisivel.exibir) {
              <div class="central_atendimento_evento_item p-2" (mouseover)="visualizarEvento(centralAtendimentoEventoVisivel.visualizado, centralAtendimentoEventoVisivel.id)">
                <div class="d-flex justify-content-between align-items-center">
                  <!-- Imagem -->
                  <div class="pr-2">
                    @if (centralAtendimentoEventoVisivel.tipo == 'email') {
                      <img class="central_atendimento_evento_item_imagem_movel" src="../../../assets/icones/icone_email.png" alt="E-mail" />
                    }
                    @if (centralAtendimentoEventoVisivel.tipo == 'facebook') {
                      <img class="central_atendimento_evento_item_imagem_movel" src="../../../assets/icones/icone_facebook.png" alt="Facebook" />
                    }
                    @if (centralAtendimentoEventoVisivel.tipo == 'telefonia') {
                      <img class="central_atendimento_evento_item_imagem_movel" src="../../../assets/icones/icone_telefonia.png" alt="Telefonia" />
                    }
                    @if (centralAtendimentoEventoVisivel.tipo == 'whatsapp') {
                      <img class="central_atendimento_evento_item_imagem_movel" src="../../../assets/icones/icone_whatsapp.png" alt="WhatsApp" />
                    }
                  </div>
                  <!-- Título/Mensagem/Ações -->
                  <div class="flex-grow-1">
                    <div class="d-flex flex-column">
                      <div class="flex-grow-1 central_atendimento_evento_item_titulo pr-2">
                        {{ centralAtendimentoEventoVisivel.titulo }}
                      </div>
                      <div class="flex-grow-1 central_atendimento_evento_item_mensagem pr-2">
                        <div class="d-flex">
                          <div class="flex-grow-1 d-flex flex-column">
                            <div [ngClass]="!centralAtendimentoEventoVisivel.visualizado ? 'font-weight-bold' : ''">
                              {{ centralAtendimentoEventoVisivel.mensagem }}
                            </div>
                            @if (centralAtendimentoEventoVisivel.identificacao != '') {
                              <div [ngClass]="!centralAtendimentoEventoVisivel.visualizado ? 'font-weight-bold' : ''">
                                {{ centralAtendimentoEventoVisivel.identificacao }}
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Ações -->
                  <div>
                    <!-- (Telefonia) -->
                    @if (centralAtendimentoEventoVisivel.tipo == 'telefonia' && centralAtendimentoEventoVisivel.atender) {
                      <div class="pl-2">
                        <button class="btn btn-secondary btn_acao" type="button" (click)="telefoniaAtender(centralAtendimentoEventoVisivel.codigo_no_erp_do_cliente)">Atender</button>
                      </div>
                    }
                    @if (centralAtendimentoEventoVisivel.tipo == 'telefonia' && centralAtendimentoEventoVisivel.redirecionar) {
                      <div class="pl-2">
                        <button class="btn btn-secondary btn_acao" type="button" (click)="telefoniaRedirecionar(centralAtendimentoEventoVisivel.codigo_no_erp_do_cliente)">Redirecionar</button>
                      </div>
                    }
                    @if (centralAtendimentoEventoVisivel.tipo == 'telefonia' && centralAtendimentoEventoVisivel.tentar_novamente) {
                      <div class="pl-2">
                        <button class="btn btn-secondary btn_acao" type="button" (click)="telefoniaTentarNovamente()">Tentar Novamente</button>
                      </div>
                    }
                  </div>
                  <!-- Data/Hora -->
                  <div class="central_atendimento_evento_item_datahora text-secondary pl-2">
                    {{ centralAtendimentoEventoVisivel.data_hora | date: 'dd/MM HH:mm:ss' }}
                  </div>
                  <!-- Ações (Evento) -->
                  <div class="pl-2">
                    <i class="fa fa-remove central_atendimento_evento_item_acao" placement="left" ngbTooltip="Excluir" (click)="excluirEvento(centralAtendimentoEventoVisivel.id)"></i>
                  </div>
                </div>
              </div>
            }
          }
          <!-- Nenhum (Evento) -->
          @if (centralAtendimentoEventosVisiveis.length == 0) {
            <div class="d-flex justify-content-center align-items-center central_atendimento_evento_item_nenhum">
              <div>
                Nenhum evento localizado!
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
}

<!-- Chat -->

@if (exibirChat) {
  <div class="central_atendimento_movel ml-4 mr-4" #centralAtendimentoChat>
    <div class="d-flex flex-column">
      <div class="central_atendimento_titulo_movel p-3"
        (mousedown)="onMouseDownChat($event)"
        (mouseleave)="onMouseLeaveChat()"
        (mousemove)="onMouseMoveChat($event)"
        (mouseup)="onMouseUpChat()">
        <!-- Título -->
        <div class="d-flex justify-content-between">
          <div class="d-flex flex-wrap">
            <div class="pr-2">
              @if (clienteSelecionado != null) {
                <b>{{ clienteSelecionado.name.substring(0, 50) }}</b>
              }
              @if (numeroSelecionado != '') {
                <b>{{ numeroSelecionado }}</b>
              }
            </div>
          </div>
          <!-- Ações -->
          <div class="d-flex">
            <div class="pr-2" (click)="iniciarWhatsAppTransferir(whatsAppTransferir)">
              <i class="fa fa-reply central_atendimento_titulo_acoes" placement="left" ngbTooltip="Transferir"></i>
            </div>
            @if (clienteSelecionado != null) {
              <div class="pr-2" (click)="whatsAppRegistrar(clienteSelecionado.codigo_no_erp_do_cliente)">
                <i class="fa fa-thumb-tack central_atendimento_titulo_acoes" placement="left" ngbTooltip="Registrar"></i>
              </div>
            }
            <div (click)="fecharChat()">
              <i class="fa fa-remove central_atendimento_titulo_acoes" placement="left" ngbTooltip="Fechar"></i>
            </div>
          </div>
        </div>
      </div>
      <!-- Conteúdo -->
      <div class="central_atendimento_conteudo p-1" (scroll)="onScroll($event)" #centralAtendimentoChatConteudo>
        <!-- Anexar -->
        @if (canaisComunicacaoWhatsAppStatus != null && canaisComunicacaoWhatsAppStatus.connected && exibirAnexar && arquivo.files.length == 0) {
          <div class="d-flex flex-column justify-content-center align-items-center central_atendimento_conteudo_expandido">
            <div class="pt-2">
              <button class="btn btn-info btn_formulario" type="button" (click)="iniciarArquivo('documento')">Documento</button>
            </div>
            <div class="pt-2">
              <button class="btn btn-info btn_formulario" type="button" (click)="iniciarArquivo('imagem')">Imagem</button>
            </div>
            <div class="pt-2">
              <button class="btn btn-info btn_formulario" type="button" (click)="iniciarArquivo('sticker')">Sticker</button>
            </div>
            <div class="pt-2">
              <button class="btn btn-danger btn_formulario" type="button" (click)="cancelarAnexar()">Cancelar</button>
            </div>
          </div>
        }
        <!-- Arquivo -->
        @if (canaisComunicacaoWhatsAppStatus != null && canaisComunicacaoWhatsAppStatus.connected && arquivo.files.length > 0) {
          <div class="d-flex flex-column justify-content-center align-items-center central_atendimento_conteudo_expandido">
            <div>
              @if (arquivo.files[0].type == '' || arquivo.files[0].type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                <img class="central_atendimento_conteudo_expandido_imagem" src="../../../assets/extensoes/desconhecida.png" alt="Arquivo" />
              }
              @if (arquivo.files[0].type == 'image/bmp') {
                <img class="central_atendimento_conteudo_expandido_imagem" src="../../../assets/extensoes/bmp.png" alt="Arquivo" />
              }
              @if (arquivo.files[0].type == 'image/jpeg') {
                <img class="central_atendimento_conteudo_expandido_imagem" src="../../../assets/extensoes/jpg.png" alt="Arquivo" />
              }
              @if (arquivo.files[0].type == 'application/pdf') {
                <img class="central_atendimento_conteudo_expandido_imagem" src="../../../assets/extensoes/pdf.png" alt="Arquivo" />
              }
              @if (arquivo.files[0].type == 'image/png') {
                <img class="central_atendimento_conteudo_expandido_imagem" src="../../../assets/extensoes/png.png" alt="Arquivo" />
              }
            </div>
            <div class="pt-2">
              <b>{{ arquivo.files[0].name.toUpperCase() }}</b>
            </div>
            <div class="pt-2">
              <button class="btn btn-danger btn_formulario" type="button" (click)="removerArquivo()">Remover</button>
            </div>
          </div>
        }
        <!-- Áudio -->
        @if (canaisComunicacaoWhatsAppStatus != null && canaisComunicacaoWhatsAppStatus.connected && exibirAudio) {
          <div class="d-flex flex-column justify-content-center align-items-center central_atendimento_conteudo_expandido">
            <div>
              @if (!gravandoAudio) {
                <button class="btn btn-info btn_formulario" type="button" (click)="iniciarAudioGravacao()">Iniciar Gravação</button>
              }
            </div>
            @if (gravandoAudio) {
              <div class="pt-2">
                <div class="d-flex flex-column align-items-center">
                  <div>
                    <img class="central_atendimento_conteudo_audio_equalizador" src="assets/whatsapp/audio.gif" alt="Áudio" />
                  </div>
                  <div class="pt-2">
                    <button class="btn btn-danger btn_formulario" type="button" (click)="pararAudioGravacao()">Parar Gravação</button>
                  </div>
                </div>
              </div>
            }
            @if (audioURL != '') {
              <div class="pt-2">
                <audio controls controlsList="nodownload">
                  <source [src]="domSanitizer.bypassSecurityTrustUrl(audioURL)" [type]="" />
                </audio>
              </div>
            }
            @if (!gravandoAudio) {
              <div class="pt-2">
                <button class="btn btn-danger btn_formulario" type="button" (click)="cancelarAudio()">Cancelar</button>
              </div>
            }
          </div>
        }
        <!-- Carregando -->
        @if (canaisComunicacaoWhatsAppStatus != null && canaisComunicacaoWhatsAppStatus.connected && !chatCarregado) {
          <div class="d-flex justify-content-center align-items-center central_atendimento_conteudo_expandido">
            <img src="assets/loader.gif" alt="Loader" />
          </div>
        }
        <!-- Instância -->
        @if (canaisComunicacaoWhatsAppStatus != null && !canaisComunicacaoWhatsAppStatus.connected) {
          <div class="d-flex justify-content-center align-items-center central_atendimento_conteudo_expandido">
            <div>
              Instância inativa!
            </div>
          </div>
        }
        <!-- Mensagens -->
        @if (canaisComunicacaoWhatsAppStatus != null && canaisComunicacaoWhatsAppStatus.connected && !exibirAnexar && !exibirAudio && arquivo.files.length == 0) {
          <div class="d-flex flex-column">
            @for (canalComunicacaoWhatsAppChat of canaisComunicacaoWhatsAppChat; track canalComunicacaoWhatsAppChat) {
              <div class="p-1 mb-1" [ngClass]="canalComunicacaoWhatsAppChat.fromMe ? 'central_atendimento_mensagem_enviada align-self-end' : 'central_atendimento_mensagem_recebida align-self-start'">
                <div class="central_atendimento_mensagem_container p-1">
                  <div class="d-flex flex-column">
                    <!-- Áudio -->
                    @if (canalComunicacaoWhatsAppChat.audio != null) {
                      <div>
                        <audio controls controlsList="nodownload">
                          <source [src]="domSanitizer.bypassSecurityTrustUrl(canalComunicacaoWhatsAppChat.audio.audioUrl)" [type]="canalComunicacaoWhatsAppChat.audio.mimeType" />
                        </audio>
                      </div>
                    }
                    <!-- Documento -->
                    @if (canalComunicacaoWhatsAppChat.document != null) {
                      <div>
                        <div class="d-flex flex-column align-items-center">
                          @if (canalComunicacaoWhatsAppChat.document.thumbnailUrl != null) {
                            <img class="central_atendimento_mensagem_documento" [src]="canalComunicacaoWhatsAppChat.document.thumbnailUrl" alt="Documento" />
                          }
                          <div class="d-flex">
                            <div>
                              {{ canalComunicacaoWhatsAppChat.document.fileName }}
                            </div>
                            <div class="pl-2">
                              <i class="fa fa-download central_atendimento_mensagem_acao" placement="left" ngbTooltip="Abrir" (click)="whatsAppAbrirDocumento(canalComunicacaoWhatsAppChat.document.documentUrl)"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                    <!-- Imagem -->
                    @if (canalComunicacaoWhatsAppChat.image != null) {
                      <div>
                        <img class="central_atendimento_mensagem_imagem" [src]="canalComunicacaoWhatsAppChat.image.imageUrl" alt="Imagem" (click)="modalWhatsAppImagens(whatsAppImagens, canalComunicacaoWhatsAppChat.image)" />
                        @if (canalComunicacaoWhatsAppChat.image.caption != null) {
                          <div class="pt-1">
                            {{ canalComunicacaoWhatsAppChat.image.caption }}
                          </div>
                        }
                      </div>
                    }
                    <!-- Sticker -->
                    @if (canalComunicacaoWhatsAppChat.sticker != null) {
                      <div class="d-flex align-items-center central_atendimento_mensagem_sticker">
                        <img class="central_atendimento_mensagem_sticker_imagem" [src]="canalComunicacaoWhatsAppChat.sticker.stickerUrl" alt="Sticker" />
                      </div>
                    }
                    <!-- Texto -->
                    @if (canalComunicacaoWhatsAppChat.text != null) {
                      <div>
                        {{ canalComunicacaoWhatsAppChat.text.message }}
                      </div>
                    }
                    <!-- Data/Hora -->
                    <div class="central_atendimento_mensagem_hora text-secondary align-self-end">
                      <div class="d-flex">
                        <div>{{ canalComunicacaoWhatsAppChat.data_hora | date: 'HH:mm' }}</div>
                        @if (canalComunicacaoWhatsAppChat.fromMe) {
                          <div class="pl-1">
                            @if (canalComunicacaoWhatsAppChat.status == 'SENT') {
                              <div class="align-items-center">
                                <img class="central_atendimento_mensagem_status" src="assets/whatsapp/sent.png" alt="Enviada" />
                              </div>
                            }
                            @if (canalComunicacaoWhatsAppChat.status == 'RECEIVED') {
                              <div class="align-items-center">
                                <img class="central_atendimento_mensagem_status" src="assets/whatsapp/received.png" alt="Recebida" />
                              </div>
                            }
                            @if (canalComunicacaoWhatsAppChat.status == 'READ') {
                              <div class="align-items-center">
                                <img class="central_atendimento_mensagem_status" src="assets/whatsapp/read.png" alt="Lida" />
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
      <!-- Enviar -->
      <div class="p-2">
        <div class="d-flex flex-row">
          <div class="pr-2" (click)="iniciarAudio()">
            <i class="fa fa-microphone central_atendimento_enviar_acoes" placement="top" ngbTooltip="Áudio"></i>
          </div>
          <div class="pr-2" (click)="iniciarAnexar()">
            <i class="fa fa-paperclip central_atendimento_enviar_acoes" placement="top" ngbTooltip="Anexar"></i>
          </div>
          <input class="central_atendimento_enviar_arquivo" type="file" accept=".bmp, .docx, .doc, .jpg, .jpeg, .pdf, .png, .txt, .xlsx" #arquivo />
          <div class="flex-grow-1">
            <input class="form-control form-control-sm" type="text" name="chatMensagem" placeholder="Mensagem" (keyup.enter)="whatsAppEnviarMensagem()" [(ngModel)]="chatMensagem" />
          </div>
          <div class="pl-2">
            <button class="btn btn-success btn_enviar" type="button" (click)="whatsAppEnviarMensagem()" [disabled]="(canaisComunicacaoWhatsAppStatus != null && !canaisComunicacaoWhatsAppStatus.connected) || !chatCarregado">Enviar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
}
